import { createRouter, createWebHistory } from "vue-router";
import Start from "../views/Start.vue";
import Categories from '../views/Categories.vue';
import Category from '../views/Category.vue';
import Story from '../views/Story.vue';
import Result from '../views/Result.vue';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/:locale",
            children: [
                {
                    path: "",
                    name: "start",
                    component: Start,
                },
                {
                    path: "categories",
                    name: "categories",
                    component: Categories,
                },
                {
                    path: "category/:categoryId",
                    name: "category",
                    component: Category,
                },
                {
                    path: "story/:categoryId/:storyId",
                    name: "story",
                    component: Story,
                },
                {
                    path: "result/:categoryId/:storyId",
                    name: "result",
                    component: Result,
                },
            ]
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        // always scroll to top
        return { top: 0 };
    },
});

export default router;
